import { jsx as _jsx } from "react/jsx-runtime";
// TODO: Drop this once we have a Circular Button component
export const CalendarNavButton = (props) => {
    return (_jsx("button", Object.assign({ type: 'button', className: `
        nucleus-box-border nucleus-inline-flex nucleus-h-8 nucleus-w-8 nucleus-max-w-full nucleus-cursor-pointer nucleus-items-center nucleus-justify-center nucleus-border-none nucleus-bg-transparent nucleus-transition-colors nucleus-m-0
        nucleus-rounded-full
        hover:nucleus-bg-neutral-600 dark:hover:nucleus-bg-neutral-300
        hover:nucleus-text-white
        nucleus-text-text-primary
        focus:nucleus-outline-none focus:nucleus-ring-2 focus:nucleus-ring-primary-500
        focus-visible:nucleus-text-text-primary active:nucleus-bg-primary-500
        disabled:nucleus-pointer-events-none
      ` }, props)));
};
//# sourceMappingURL=calendar_nav_button.js.map